
  Vue.component('seekers-relationships-contact-list', {
    props: {
      visible: { type: Boolean, default: true },
      selectedId: { type: Number },
      reSend: { type: Function, required: true },
      relationshipType: { type: Number }
    },
    data() {
      return {
        formInterfaces: {},
        contactsList: [],

        columnsList: [
          { id: 'ContactEmail', label: 'Email', sortable: true },
          { id: 'ContactFirstName', label: 'Nome', sortable: true },
          { id: 'ContactLastName', label: 'Cognome', sortable: true },
          { id: 'ContactCompany', label: 'Azienda', sortable: true },
          { id: 'CreateDate', label: 'Data contatto', type: 'date', sortable: true }
        ],
        statusList: [
          {
            key: 'link',
            id: 'LinkOpened',
            value: 1,
            labelOn: 'Link mail aperto',
            labelOff: 'Link mail non aperto',
            icon: 'fa-link',
            style: 'success'
          },
          {
            key: 'registration',
            id: 'RegistrationDone',
            value: 2,
            labelOn: 'Registrazione effettuata',
            labelOff: 'Registrazione non effettuata',
            icon: 'fa-sign-in',
            style: 'warning'
          },
          {
            key: 'registration',
            id: 'ConnectionConfirmed',
            value: 4,
            labelOn: 'Registrazione confermata',
            labelOff: 'Registrazione non confermata',
            icon: 'fa-sign-in',
            style: 'success'
          },
          {
            key: 'link',
            id: 'GlobalLinkOpened',
            value: 1,
            type: 8,
            labelOn: 'Link globale aperto',
            labelOff: 'Link globale aperto',
            icon: 'fa-globe',
            style: 'success'
          }
          // {
          //  key: 'privacy',
          //  id: 'PrivacyAccepted',
          //  value: 8,
          //  labelOn: 'Privacy accettata',
          //  labelOff: 'Privacy non ancora accettata',
          //  icon: 'fa-user-secret'
          // }
        ]
      }
    },
    template: '#seekers-relationships-contact-list',
    computed: {
      uniqueStatusList() {
        return Array.from(new Set(this.statusList.map(item => item.key))).map(item => ({ key: item }))
      },
      actionsList() {
        const defaultAction = [
          { id: 'delete', label: 'Elimina', icon: 'fa-trash', action: this.handleDeleteRow },
          {
            id: 'hurry',
            label: 'Invia sollecito',
            icon: 'fa-paper-plane',
            action: this.handleReSend,
            hideWhen: { RelationshipType: 8 }
          }
        ]
        const relType2Action = [
          {
            id: 'widget',
            label: 'Widget e QRCode',
            icon: 'fa-qrcode',
            action: this.handleWidget,
            hideWhen: { RelationshipType: 8 }
          }
        ]

        switch (this.relationshipType) {
          case 2:
            return [...defaultAction, ...relType2Action]
            break
          default:
            return defaultAction
            break
        }
      }
    },
    watch: {},
    methods: {
      handleWidget(event, item) {
        const id = item.Id
        axios
          .get(`/api/v1/seekers-relationships/${id}`)
          .then(response => {
            const { data } = response
            if (data.SeekerToId) {
              axios.get(`/api/v1/widget?transparent=true&idseeker=${data.SeekerToId}`).then(resp2 => {
                EventBus.$emit('vnPopup', {
                  style: 'popup',
                  type: 'light',
                  message: `<textarea style="min-height:150px" class="h5 w-100" />${resp2.data.embed} </textarea>`,
                  component: 'tab-view-pager',
                  options: {
                    pages: [
                      {
                        id: 1,
                        label: 'Widget',
                        title: `Inserisci nel tuo sito il form di contatto`,
                        content: `<textarea readonly style="min-height:150px" class="w-100 code" />${resp2.data.embed}</textarea>`
                      },
                      {
                        id: 2,
                        label: 'Pulsante',
                        title: `Inserisci nel tuo sito il pulsante che rimanda alla pagina di LearK dedicata alla tua azienda.`,
                        content: `<textarea readonly style="min-height:150px" class="w-100 code" />${resp2.data.link}</textarea>`
                      },
                      {
                        id: 3,
                        label: 'QR-Code',
                        title: `Stampa o condividi il QR Code.`,
                        content: {
                          component: 'qrc-display-panel',
                          options: {
                            seekerId: data.SeekerToId,
                            qrcUrl: `/api/v1/qrcode/get-image?idseeker=${data.SeekerToId}`,
                            embedded: true
                          }
                        }
                      }
                    ]
                  },
                  actions: [{ label: 'OK', icon: 'fa-check-circle', style: 'success' }]
                })
              })
            } else {
              EventBus.$emit('vnShow', {
                type: 'danger',
                message: `Il contatto non ha ancora confermato l'iscirzione.`
              })
            }
          })
          .catch(error => {
            EventBus.$emit('vnShow', {
              type: 'danger',
              message: `Le modifiche non sono state salvate: ${error}`
            })
          })
          .then(() => {
            // always executed
          })
      },

      handleQRCode(event, item) {
        const id = item.Id
        axios
          .get(`/api/v1/seekers-relationships/${id}`)
          .then(response => {
            const { data } = response
            if (data.SeekerToId) {
              EventBus.$emit('vnPopup', {
                style: 'popup',
                message: `<img style="width:70%" src="/api/v1/qrcode/get-image?transparent=true&idseeker=${data.SeekerToId}" />`,
                actions: [{ label: 'OK', icon: 'fa-check-circle', style: 'success' }]
              })
            } else {
              EventBus.$emit('vnShow', {
                type: 'danger',
                message: `Il contatto non ha ancora confermato l'iscirzione.`
              })
            }
          })
          .catch(error => {
            EventBus.$emit('vnShow', {
              type: 'danger',
              message: `Le modifiche non sono state salvate: ${error}`
            })
          })
          .then(() => {
            // always executed
          })
      },
      handleReSend(event, item) {
        const id = item.Id
        EventBus.$emit('vnPopup', {
          style: 'popup',
          message: `Vuoi spedire nuovamente l'invito al contatto selezionato?`,
          actions: [
            { label: 'OK', icon: 'fa-check-circle', action: () => this.reSend(event, id), style: 'success' },
            { label: 'Annulla', icon: 'fa-times-circle', style: 'info' }
          ]
        })
      },
      handleDeleteRow(event, item) {
        const id = item.Id
        EventBus.$emit('vnPopup', {
          style: 'popup',
          message: `Vuoi procedere con la cancellazione del contatto selezionato?`,
          actions: [
            { label: 'OK', icon: 'fa-check-circle', action: () => this.deleteRow(event, id), style: 'success' },
            { label: 'Annulla', icon: 'fa-times-circle', style: 'info' }
          ]
        })
      },
      deleteRow(event, id) {
        const self = this
        axios
          .get(`/api/v1/seekers-relationships/delete/${id}`)
          .then(response => {
            const { data } = response
            this.contactsList = this.contactsList.filter(cl => cl.Id != id)

            EventBus.$emit('vnShow', {
              type: 'success',
              message: `La cancellazione è stata effettuata correttamente.`
            })
          })
          .catch(error => {
            EventBus.$emit('vnShow', {
              type: 'danger',
              message: `Le modifiche non sono state salvate: ${error}`
            })
          })
          .then(() => {
            // always executed
          })
      },
      stopAll(event, id) {
        event.stopPropagation()
        event.preventDefault()
        return false
      },
      beforeEnter: () => {
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: 'smooth'
        })
      },
      getFormInterface(formInterface) {
        this.formInterfaces[formInterface.key] = formInterface
      },
      setContactsList(data) {
        const self = this
        self.contactsList = data.map(item => {
          self.statusList.forEach(status => {
            const value = (item.RelationshipStatus & status.value) === status.value
            const checkType = status.hasOwnProperty('type') && status.type === item.RelationshipType
            const label = value ? status.labelOn : status.labelOff
            if (checkType) {
              item[status.key] = { ...status, value, label }
            } else if (!status.hasOwnProperty('type')) {
              item[status.key] = item[status.key] && !value ? item[status.key] : { ...status, value, label }
            }
          })
          return item
        })
      },
      getErrorResponse(error) {
        console.log(error)
        let retVal = error
        if (error.response) {
          retVal = { status: error.response.status }
          if (error.response.data && error.response.data.error) {
            retVal.error = error.response.data.error
          }
        }
        return retVal
      },
      handleSessionExpired() {
        EventBus.$emit('vnPopup', {
          type: 'danger',
          message: `<p><b>La sessione è scaduta</b></p><p>La pagina verrà ricaricata per permettere di effettuare nuovamente il login</p>`,
          actions: [
            {
              label: 'OK',
              icon: 'fa-check-circle',
              action: () => {
                window.location.reload()
              },
              style: 'danger'
            }
          ]
        })
      }
    },
    mounted() {
      const self = this
      axios
        .get(`/api/v1/seekers-relationships`)
        .then(response => {
          const { data } = response
          self.setContactsList(data)
          if (self.selectedId)
            setTimeout(
              () => document.getElementById(`row-${self.selectedId}`).scrollIntoView({ behavior: 'smooth' }),
              200
            )
        })
        .catch(error => {
          const errorResponse = self.getErrorResponse(error)
          if ((errorResponse.status = 401)) {
            self.handleSessionExpired()
          } else {
            EventBus.$emit('vnShow', {
              type: 'danger',
              message: `Le modifiche non sono state salvate: ${error}`
            })
            self.nextPage()
          }
        })
        .then(() => {
          // always executed
        })
    },
    beforeDestroy() {
      // EventBus.$off('vnShow', this.vnShow)
    }
  })
